export const receiptPdfFilename = (receipt) => {
  const number = receipt?.receipt_number;
  const draft = receipt?.draft === true || !number || number === 'Vázlat';
  const suffix = draft ? `Vázlat_${receipt?.id ?? 'új'}` : number;
  const safeSuffix = Array.from(String(suffix), char => char.charCodeAt(0) < 32 ? '_' : char).join('');
  return `Bizonylat_${safeSuffix.replace(/[\\/:*?"<>|]/g, '_')}.pdf`;
};
